<template>
  <li>
    <hr class="dropdown-divider">
  </li>
</template>

<script>
export default {
  name: "Li-Divider"
}
</script>

<style scoped>

</style>